import { ComponentPropsWithoutRef, ComponentRef, FC, ReactNode, Ref } from 'react';
import classNames from 'classnames';
import { Drawer } from 'vaul';

import styles from './BottomSheetHeader.module.css';

export type BottomSheetHeaderProps = {
  children: ReactNode;
  className?: string;
  ref?: Ref<ComponentRef<typeof Drawer.Title>>;
} & Omit<ComponentPropsWithoutRef<typeof Drawer.Title>, 'className'>;

/** Заголовок шторки — рендерится как Drawer.Title, даёт aria-labelledby автоматически. */
const BottomSheetHeader: FC<BottomSheetHeaderProps> = ({ children, className, ref, ...rest }) => (
  <Drawer.Title
    ref={ref}
    {...rest}
    className={classNames(styles.header, className)}>
    {children}
  </Drawer.Title>
);

export default BottomSheetHeader;
